import aa from 'search-insights';

import { buildAlgoliaClickedAfterSearchPayload, type HitWithQueryID } from '@/wabunka-src/common/utils/algolia/events/searchResultClicked';
import { captureException } from '@/wabunka-src/common/utils/sentry';

/**
 * Algolia Insights の `clickedObjectIDsAfterSearch` イベント送信を扱う composable。
 *
 * runtimeConfig 経由のインデックス名取得・search-insights `aa()` 呼び出し・Sentry 通知といった
 * 副作用は `common/utils` 配下に置けないため、ここに集約する（utils は純粋関数のみとする方針）。
 *
 * @see docs/Design Doc/キーワード検索.md UC4
 */
export const useAlgoliaClickedEvent = () => {
  const sendClickedAfterSearch = (hit: HitWithQueryID, eventName = 'Search Result Clicked') => {
    try {
      const runtimeConfig = useRuntimeConfig();
      const indexName = runtimeConfig.public.ALGOLIA_INDEX_NAME as string | undefined;
      const payload = buildAlgoliaClickedAfterSearchPayload(hit, indexName, eventName);
      if (!payload) return;
      aa('clickedObjectIDsAfterSearch', payload);
    } catch (error) {
      const newError = new Error(`Failed to send Algolia clickedObjectIDsAfterSearch event: ${(error as Error).message}`);
      captureException(newError, 'wabunka');
    }
  };

  return { sendClickedAfterSearch };
};
